import ArticleSearch from './ArticleSearch';

export default ArticleSearch;
